import type { Slot } from './labels.ts';
import { Sticker, type StickerLook } from './Sticker.tsx';
import styles from './Labels.module.css';

export type LabelPagesProps = {
  pages: readonly (readonly Slot[])[];
  look: StickerLook;
};

export const LabelPages = ({ pages, look }: LabelPagesProps) => (
  <div className={[styles['pages'], styles[look.format]].join(' ')} dir="ltr">
    {pages.map((slots, page) => (
      <section key={page} className={styles['page']}>
        {slots.map((slot, position) => (
          <Sticker key={position} subject={slot} look={look} />
        ))}
      </section>
    ))}
  </div>
);
